module.exports = __webpack_public_path__ + "img/receive_rule.a72d05ab.png";